import { render, staticRenderFns } from "./addPayee.vue?vue&type=template&id=730c165c&scoped=true"
import script from "./addPayee.vue?vue&type=script&lang=js"
export * from "./addPayee.vue?vue&type=script&lang=js"
import style0 from "./addPayee.vue?vue&type=style&index=0&id=730c165c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730c165c",
  null
  
)

export default component.exports